import { createAsyncThunk } from '@reduxjs/toolkit';
import { applyOptimisticUpdate, revertOptimisticUpdate } from '../slice.js';

// Optimistic profile update thunk
export const updateProfileOptimistic = createAsyncThunk(
  'profile/updateProfileOptimistic',
  async ({ userId, updates, updateFunction }, { dispatch, getState, rejectWithValue }) => {
    try {
      // Apply optimistic update immediately
      dispatch(applyOptimisticUpdate(updates));

      // Perform actual update
      const result = await updateFunction(userId, updates);

      // Confirm the update was successful
      return { updates, result };
    } catch (error) {
      // Revert optimistic update on error
      dispatch(revertOptimisticUpdate());
      return rejectWithValue(error.message);
    }
  }
);
